import React from "react";
import {
  Box,
  InputAdornment,
  TextField,
  Typography,
  DuplicateIcon,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const TextFieldWithCopy = () => {
  return (
    <>
      <Box p={3}>
        <Typography variant={"h6"} color={"text.primary"}>
          Basic TextField with Copy button
        </Typography>
      </Box>
      <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
        <PreviewAndEditor
          language={"js"}
          value={
            " <TextField\n" +
            "      value={'JHvZP7HRfU5RjdHsOWcXsdb6JNuYzvdfd'}\n" +
            "      InputProps={{\n" +
            "          endAdornment: (\n" +
            "              <InputAdornment position='end' sx={{ '& svg': { m: 0, mr: 0.5 },cursor: \"pointer\" }}>\n" +
            "                  <p style={{ display: 'inline-flex' }}>\n" +
            "                   <CopyIcon fontSize={'small'} />\n" +
            "                       Copy\n" +
            "                  </p>\n" +
            "              </InputAdornment>\n" +
            "          ),\n" +
            "      }}\n" +
            "  />"
          }
        >
          <Box width={300}>
            <TextField
              value={"JHvZP7HRfU5RjdHsOWcXsdb6JNuYzvdfd"}
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    sx={{ "& svg": { m: 0, mr: 0.5 }, cursor: "pointer" }}
                  >
                    <p style={{ display: "inline-flex" }}>
                      <DuplicateIcon fontSize={"small"} />
                      Copy
                    </p>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </PreviewAndEditor>
      </Box>
    </>
  );
};

export default TextFieldWithCopy;
